// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"443":"about","757":"game"}[chunkId] + "." + {"443":"f55c0ab0","757":"2bdfae1d"}[chunkId] + ".js";
};